module.exports = __webpack_public_path__ + "img/shop6.17dd7cd4.png";